.tabs {
  display: flex;
  width: 100%;
}

.tab {
  width: 50%;
  border-radius: 5px 5px 0 0;
  border: none;
  border-bottom: 2px var(--paletteBlue0) solid;

  .tabInner {
    padding: 5px 0;
    border-radius: 5px 5px 0 0;
  }

  &:not(.selected) {
    .tabInner {
      border-top: 2px var(--paletteBlue0) solid;
      border-left: 2px var(--paletteBlue0) solid;
      border-right: 2px var(--paletteBlue0) solid;
      opacity: 0.5;
    }
  }

  &.selected {
    border-top: 2px var(--paletteBlue0) solid;
    border-left: 2px var(--paletteBlue0) solid;
    border-right: 2px var(--paletteBlue0) solid;
    border-bottom: none;
  }
}

.dateRange {
  height: 40px;
  display: flex;
  width: 100%;
  background-color: var(--paletteWhite1);
  border-radius: 5px;
  padding: 5px;
  justify-content: center;
  justify-content: space-between;
  align-items: center;
}

.actionsWrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacingMd);

  span > svg {
    margin-bottom: -2px;
  }
}

.carouselWrapper {
  width: inherit;

  // margin for safari not to overlap weekday select
  margin: 0 0 1px 2px;
}

.noTabsLoadLabel {
  width: 100%;
  margin: 15px 0 5px;
  border-radius: 5px 5px 0 0;
  text-align: center;
}
